// @ts-check

/**
 * CUSTOM: "Fjern"-knappen på varer i kurven (snippets/cart-item.liquid → [data-gw-remove]).
 * Flyttet ud af assets/gift-wrap-upsell.js (8/10 2026), så den virker uanset om
 * gaveæske-funktionerne er slået til eller fra. Logik uændret.
 * Indlæses fra: snippets/cart-drawer.liquid
 */
(function () {
  /** @type {any} */
  const win = window;
  if (win.__customCartRemoveInit) return;
  win.__customCartRemoveInit = true;

  const root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';

  // Event-delegation – kurven gen-renderes, så vi lytter på hele dokumentet.
  document.addEventListener('click', function (e) {
    const target = /** @type {HTMLElement | null} */ (e.target);
    if (!target || !target.closest) return;
    const button = /** @type {HTMLElement | null} */ (target.closest('[data-gw-remove]'));
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();

    const key = button.getAttribute('data-key');
    if (!key || button.dataset.busy) return;
    button.dataset.busy = '1';
    button.style.opacity = '0.4';

    fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        button.dataset.busy = '';
        button.style.opacity = '';
      });
  });
})();
